import React, { Dispatch } from 'react'
import {doSignup} from './signupActions.js'
import './Account.css'
import LoginScaffold from './LoginScaffold.js'

type SignupFormProps =
    {
        dispatch: Dispatch<any>,
        history: History
    }

class SignupForm extends React.Component<SignupFormProps, {}> {
    state = {
        fullName: "",
        companyName: "",
        email: "",
        password: "",
        error: "",
        showPassword: false
    }

    componentDidMount() {
        const email = sessionStorage.getItem('signupEmail')
        sessionStorage.removeItem('signupEmail')
        if (email) this.setState({email})
    }

    async signup(e : Event) {
        e.preventDefault()
        const response = await doSignup(this.state.fullName, this.state.companyName, this.state.email, this.state.password)

        if (!response.success) {
            this.setState({error: response.message || "An error occurred. Please try again."})
        }
        else {
            this.setState({error: ""})
            window.location.href = `/`
        }
    }

    render() {
        return (
            <LoginScaffold>
                <a className="Login-back-button" href="/sign-in">← Back</a>
                <header className="Login-header">Create your account.</header>
                {this.state.error && <p className="Login-header-error" role="alert">{this.state.error}</p>}
                <form className="Login-form" onSubmit={this.signup.bind(this)}>
                    <div className="Login-form-inputs">
                        <div>
                            <input autoFocus type="text" className="Login-input" placeholder="First and last name" value={this.state.fullName} onChange={e => this.setState({fullName: e.target.value})}></input>
                        </div>
                        <div>
                            <input type="text" className="Login-input" placeholder="Company name" value={this.state.companyName} onChange={e => this.setState({companyName: e.target.value})}></input>
                        </div>
                        <div>
                            <input type="text" className="Login-input" placeholder="Email" value={this.state.email} onChange={e => this.setState({email: e.target.value})}></input>
                        </div>
                        <div>
                            <input type={this.state.showPassword ? "text" : "password"} className="Login-input" placeholder="Password" value={this.state.password} onChange={e => this.setState({password: e.target.value})}></input>
                            <label className="Login-show-password"><input type="checkbox" className="Login-input-checkbox" checked={this.state.showPassword} onChange={e => this.setState({showPassword: e.target.checked})}></input><span>Show password</span></label>
                        </div>
                    </div>
                    <button type="submit" className="primary">Create account</button>
                </form>
            </LoginScaffold>
        )
    }
}

export default SignupForm;
